import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import useToggle from "../../utils/hooks/useToggle"
import { white, black } from "../../utils/colors"

const SideBarMenuListItem = ({ data, expandAll, icon, toggleExpandAll }) => {
  const [isToggled, toggle] = useToggle(!expandAll)
  
  const handleExpand = () =>  {
    toggle(false)
  }
  
  useEffect(() => {
    if(expandAll) {
      toggle(false)
      toggleExpandAll(false)
    } else {
      toggle(false)
      toggleExpandAll(true)
    }
      
  },[expandAll])


  return (
    <>
      <ItemWrapper>
        <ButtonWrapper>
          <StyledButton onClick={handleExpand}>
            <IconBg>
              <img
                height="20"
                width="20"
                src={icon}
                alt={`${
                  data.allMarkdownRemark.edges[0].node.frontmatter.category
                } icon`}
              />
            </IconBg>
            {data.allMarkdownRemark.edges[0].node.frontmatter.category}
          </StyledButton>
          <IconWrapper
            onClick={handleExpand}
            isToggled={isToggled}
          >
            →
          </IconWrapper>
        </ButtonWrapper>
        <SideBarSubMenu expand={isToggled}>
          {data.allMarkdownRemark.edges.map(
            ({
              node: {
                fields: { slug },
                frontmatter: { title },
              },
            }) => (
              <SideBarSubMenuListItem>
                <StyledLink to={slug.slice(0, -1)}>{title}</StyledLink>
              </SideBarSubMenuListItem>
            )
          )}
        </SideBarSubMenu>
      </ItemWrapper>
    </>
  )
}

export default SideBarMenuListItem

const ItemWrapper = styled.li`
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
`

const ButtonWrapper = styled.div`
  display: flex;
`

const IconWrapper = styled.div`
  color: ${props => props.theme.text};
  transform: rotate(0deg);
  transition: all 300ms ease;


  ${({ isToggled }) =>
    isToggled
      ? css`
          transform: rotate(90deg);
          transition: all 300ms ease;
        `
      : css``};
`

const StyledButton = styled.button`
  appearance: none;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${props => props.theme.text};
  width: 100%;
  font-size: 15px;
  padding: 0;
`

const SideBarSubMenu = styled.ul`
  margin: 0 0 0 35px;
 
  display: none;
  transition: all 300ms ease;
  ${({ expand }) =>
    expand
      ? css`
  display: block;
  transition: all 300ms ease;
  padding-top: 15px;
  `
      : css`
      display: none;
    transition: all 300ms ease;
      `};
`

const SideBarSubMenuListItem = styled.li`
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
  color: ${props => props.theme.text};
  font-size: 14px;
  &:last-child {
    margin-bottom: 20px;
  }
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${props => props.theme.text};
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 20px;
`

const IconBg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  border-radius: 20px;
`
